// 编码 ID
export const encodeId = (id: any) => {
  // 使用 btoa() 将 ID 编码为 Base64
  let base64 = btoa(id);

  // 替换 Base64 中的 '+' 和 '/' 为 URL 安全字符 '-'
  // 替换 '=' 为 ''，移除填充字符
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

// 解码 ID
export const decodeId = (encodedId: any) => {
  try {
    // 检查输入参数
    if (!encodedId || typeof encodedId !== 'string') {
      return null;
    }

    // 还原 URL 安全字符为 Base64 字符
    let base64 = encodedId.replace(/-/g, "+").replace(/_/g, "/");

    // 补充填充字符 '=' 使其符合 Base64 编码的标准
    const padding = base64.length % 4;
    if (padding) {
      base64 += "=".repeat(4 - padding);
    }

    // 使用 atob() 解码 Base64 编码的 ID
    const decodedId = atob(base64);
    
    // 如果解码失败或者decodedId不为数字，返回null
    if (!decodedId || isNaN(Number(decodedId))) {
      return null;
    }
    return decodedId;
  } catch (error) {
    // 捕获 atob() 解码异常
    return null;
  }
};
